module.exports = __webpack_public_path__ + "files/777feab4abe7450fc273cf948f169dcc.svg";